import React from "react";
import { Form, Col } from "react-bootstrap";
import { push, setParam, getQueryString } from "pages/search/api/filterUrlMaker";
import { _t, i18n } from "app/i18n/i18n";

export function CoverageFilters({ gicsLevel2Names }) {
  const qs = getQueryString();
  const lang = i18n.getLanguage();

  const onFilterChange = (e) => {
    const { name } = e.target;
    const value = e.target.value.trim();
    const newQs = setParam("Page", 1);
    push(setParam(name, value, newQs));
  };

  return (
    <Form onChange={onFilterChange}>
      <header>
        <Form.Group as={Form.Row} className="mb-1">
          <Col>
            <Form.Control
              as="input"
              name="companyName"
              size="sm"
              placeholder={_t("Search for Company...")}
              defaultValue={qs.companyName}
              className="mb-1"
            />
          </Col>

          <Col>
            <Form.Control
              as="input"
              name="coveredBy"
              size="sm"
              placeholder={_t("Search for Analyst...")}
              defaultValue={qs.coveredBy}
              className="mb-1"
            />
          </Col>

          <Col xs="12" className="d-md-none" />

          <Col>
            <Form.Control as="select" name="region" size="sm" className="mb-1" defaultValue={qs.region}>
              <option value="">{_t("All Regions")}</option>
              <option value="Americas">{_t("Americas")}</option>
              <option value="EMEA">{_t("EMEA")}</option>
              <option value="Asia ex-Japan">{_t("Asia ex-Japan")}</option>
              <option value="Japan">{_t("Japan")}</option>
            </Form.Control>
          </Col>

          <Col>
            <Form.Control
              as="select"
              name="gicsLevel2"
              size="sm"
              value={qs.gicsLevel2}
              className="mb-1"
              onChange={() => {}} // do not remove this on change as it supresses the warning caused by using value instead of defaultValue
            >
              <option value="">{_t("All Sub-Sectors")}</option>
              {gicsLevel2Names.map(({ name }, idx) => {
                const industryName = name?.[lang];
                const optionValue = name?.en;
                const key = `${idx} - ${industryName}`;

                return (
                  <option key={key} value={optionValue}>
                    {industryName}
                  </option>
                );
              })}
            </Form.Control>
          </Col>

          <Col>
            <Form.Control as="select" name="currentRating" size="sm" defaultValue={qs.currentRating} className="mb-1">
              <option value="">{_t("All Ratings")}</option>
              <option value="Buy">{_t("Buy")}</option>
              <option value="Neutral">{_t("Neutral")}</option>
              <option value="Reduce">{_t("Reduce")}</option>
            </Form.Control>
          </Col>
        </Form.Group>
      </header>
    </Form>
  );
}
